import { Navigate, useLocation } from "react-router-dom";

export const OrgBillingRedirect = () => {
  const location = useLocation();
  const target = `/org/billing${location.search}`;

  return <Navigate to={target} replace />;
};
